/**
 * A version stamp on every URL under /art.
 *
 * Hostinger's CDN spent the morning of the show handing phones lossy WebP
 * copies of the pixel art — stage-arch.png left disk at 411KB and arrived as
 * 57KB — and it told those phones to keep the copy for thirty days. The
 * `no-transform` header in `public/art/.htaccess` stops it happening again,
 * but a header only helps somebody who asks for the file. Every handset that
 * came this morning already has the mangled version and will not ask again
 * until October.
 *
 * "Clear your cache" is not something you can ask an audience, so the URL
 * changes instead. A different URL is a different cache entry, and the browser
 * has no choice but to fetch it fresh.
 *
 * Bump this when the art changes, or when anything upstream has served a bad
 * copy of it.
 */
export const ART_VERSION = "2";

/** `/art/tiles.png` → `/art/tiles.png?v=2` */
export function artUrl(path: string): string {
  return `${path}?v=${ART_VERSION}`;
}
